import "./style.css";

export default class Story {
  static selector = ".story";

  constructor(block) {
    this.block = block;
    this.mounted = false;
  }

  onReady = () => {
    this.mounted = true;
  };

  onPageChangeComplete = () => {
    this.onComplete();
  };

  onComplete = () => {};
}
